"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSetPassword = exports.useAccountUpdate = exports.usePasswordChange = exports.useUpdateUserAddress = exports.useCreateUserAddress = exports.useDeleteUserAddresss = exports.useDefaultUserAddress = exports.useSignOut = exports.useSignIn = void 0;
const useMutation_1 = require("./useMutation");
exports.useSignIn = useMutation_1.mutationFactory("signIn");
exports.useSignOut = useMutation_1.mutationFactory("signOut");
// Address mutations
exports.useDefaultUserAddress = useMutation_1.mutationFactory("setUserDefaultAddress");
exports.useDeleteUserAddresss = useMutation_1.mutationFactory("setDeleteUserAddress");
exports.useCreateUserAddress = useMutation_1.mutationFactory("setCreateUserAddress");
exports.useUpdateUserAddress = useMutation_1.mutationFactory("setUpdateuserAddress");
// User mutations
exports.usePasswordChange = useMutation_1.mutationFactory("setPasswordChange");
exports.useAccountUpdate = useMutation_1.mutationFactory("setAccountUpdate");
exports.useSetPassword = useMutation_1.mutationFactory("setPassword");
//# sourceMappingURL=mutations.js.map